// firebaseConfig.js
import { initializeApp }     from "firebase/app";
import { getAnalytics }      from "firebase/analytics";
import { getFirestore }      from "firebase/firestore";
import { getAuth }           from "firebase/auth";
import { getStorage }        from "firebase/storage";

const firebaseConfig = {
    apiKey:            "AIzaSyChE_7NZiJ-rZ4AszKiUx1CG_96lM3QEGI",
    authDomain:        "luke-little-chief-official.firebaseapp.com",
    projectId:         "luke-little-chief-official",
    storageBucket: "luke-little-chief-official.firebasestorage.app",
    messagingSenderId: "1079411136377",
    appId:             "1:1079411136377:web:b340e4401dcc4edbf401a8",
    measurementId:     "G-Y8MFW8ESBC"
};

// Initialize the SDKs
const app       = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db        = getFirestore(app);
const auth      = getAuth(app);
const storage   = getStorage(app);

// Export whatever you need elsewhere
export { app, analytics, db, auth, storage };
